import * as orderApi from '../../api/orderApi'
import * as shopApi from '../../api/shopApi'
const state={
    getProductBySkuCodeInput:{},
    createOrderInput:{},
    getProductBySkuCodeOutput:{},
    createOrderOutput:{},
    hasError:false,
    errorMessage:'',
    shopList:[]
}

const getters={

}

const actions ={
    async GetProductBySkuCode({commit},getProductBySkuCodeInput){
        state.hasError=false
        const response =await orderApi.GetProductBySkuCode(getProductBySkuCodeInput);
        commit('setProductBySkuCode',response)
        return response;
    },
    async CreateOrder({commit},createOrderInput){
        state.hasError=false
        const response =await orderApi.CreateOrder(createOrderInput);
        //commit('setCreateOrder',response)
        return response;
    },
    async GetStoreList({commit}){
        state.hasError=false
        const response =await shopApi.GetStoreList();
        commit('setShopList',response)
        return response
    }
}

const mutations ={
    setProductBySkuCode(state,data){
        if(data.Status){
            state.errorMessage=''
            state.getProductBySkuCodeOutput=data.Data;
        }else{
            state.hasError=true
            state.getProductBySkuCodeOutput={}
            state.errorMessage=data.Message
        }
    },
    setCreateOrder(state,data){
        //console.log(data)
        if(data.Status){
            state.errorMessage=''
            state.createOrderOutput=data.Data;
        }else{
            state.hasError=true
            state.createOrderOutput={}
            state.errorMessage=data.Message
        }
    },
    setShopList(state,data){
        //console.log(data)
        if(data.Status){
            state.errorMessage=''
            state.shopList=data.Data;
        }else{
            state.hasError=true
            state.shopList=[]
            state.errorMessage=data.Message
        }
    },
    clear(state){
        console.log('ffff')
        state.getProductBySkuCodeInput={}
        state.createOrderInput={}
        state.getProductBySkuCodeOutput={}
        state.createOrderOutput={}
        state.hasError=false,
        state.errorMessage=''
    }
}

export default{
     namespaced:true,
     getters,
     state,
     actions,
     mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/orderfill.js